import { prescriberManagementRoles } from '@truepill/tpos-types'
import AuthLimited from 'components/AuthLimited'
import { FilledHeader } from 'components/PageStructure'
import { EditMode, NormalMode } from 'components/RXPageStructure'
import type { Prescriber, Log } from 'types'
import DemographicBlock from './components/DemographicBlock'
import EditDemographicBlock from './components/EditDemographicBlock'
import Notes from './components/Notes'
import { RXPrescriberDataContainer, RXDataContainer, RXDataColumn } from './StyledComponents'

type PrescriberProfileType = {
  prescriber: Prescriber
  isVet: boolean
  notes: Log[]
}

const PrescriberProfile = ({ prescriber, isVet, notes }: PrescriberProfileType): JSX.Element => {
  return (
    <RXPrescriberDataContainer>
      <RXDataContainer>
        <RXDataColumn>
          <FilledHeader>Demographic</FilledHeader>
          <NormalMode>
            <DemographicBlock isVet={isVet} prescriber={prescriber} />
          </NormalMode>
          <AuthLimited roles={prescriberManagementRoles}>
            <EditMode>
              <EditDemographicBlock isVet={isVet} prescriber={prescriber} />
            </EditMode>
          </AuthLimited>
        </RXDataColumn>
        <RXDataColumn>
          <FilledHeader>Critical notes</FilledHeader>
          <Notes notes={notes} />
        </RXDataColumn>
      </RXDataContainer>
    </RXPrescriberDataContainer>
  )
}

export default PrescriberProfile
